import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export const CHAT_WIDGET_ID = {
  LIB_ANSWERS: 'libanswers',
  LIBRARY_H3LP: 'libraryh3lp',
  MOSIO: 'mosio',
  REF_CHATTER: 'refchatter',
  Q_WIDGET: 'qwidget',
  UNIQUE_CHAT: 'uniquechat'
};

export default createReduxConstants('LIBRARY', {
  LIBRARY_REQUEST: null,
  LIBRARY_SUCCESS: null,
  LIBRARY_FAILURE: null
});
